"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./RadioStyles"));
var react_feather_1 = require("react-feather");
var body_1 = __importDefault(require("../../body"));
var tooltip_1 = __importDefault(require("../tooltip"));
var starStyle = {
    color: "var(--danger)",
};
var Radio = function (_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange, label = _a.label, readOnly = _a.readOnly, labelType = _a.labelType, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, _c = _a.appearance, appearance = _c === void 0 ? "default" : _c, flexDirection = _a.flexDirection, fullWidth = _a.fullWidth;
    var stars = function () {
        switch (true) {
            case labelType === "required": {
                return "*";
            }
            default: {
                return "";
            }
        }
    };
    if (appearance === "columns") {
        return (React.createElement(Styled.AdminRadioInput, null,
            label && (React.createElement(Styled.AdminRadioLabel, { readOnly: readOnly },
                labelType && React.createElement("span", { style: starStyle },
                    stars(),
                    "\u00A0"),
                label)),
            React.createElement(Styled.AdminRadioInputFormScope, { appearance: appearance, amount: options.length }, options.map(function (option) {
                var random = Math.random().toString(36).slice(2);
                return (React.createElement(tooltip_1.default, { content: option.tooltipText ? (React.createElement(body_1.default, { size: "xs", withoutMargins: true, style: { width: "max-content", maxWidth: 500 } }, option.tooltipText)) : null, position: "right", key: option.name, fullWidth: fullWidth },
                    React.createElement(Styled.AdminRadioInputItem, { onClick: function () {
                            !readOnly && !option.disabled && onChange(option.name);
                        }, key: option.name, readOnly: readOnly || option.disabled, appearance: appearance, selected: option.name === value },
                        React.createElement(Styled.ColumnTitle, { selected: option.name === value },
                            React.createElement(Styled.AdminRadioInputItemName, { readOnly: readOnly || option.disabled, "data-tip": true, "data-for": random }, option.label),
                            option.name === value && (React.createElement(Styled.SuccessIcon, null,
                                React.createElement(react_feather_1.Check, { color: "var(--snow)", size: 12 })))),
                        React.createElement(Styled.LabelContainer, { appearance: appearance }, option.content && option.content))));
            }))));
    }
    else {
        return (React.createElement(Styled.AdminRadioInput, null,
            label && (React.createElement(Styled.AdminRadioLabel, { readOnly: readOnly },
                labelType && React.createElement("span", { style: starStyle },
                    stars(),
                    "\u00A0"),
                label)),
            React.createElement(Styled.AdminRadioInputFormScope, { appearance: appearance, flexDirection: flexDirection }, options.map(function (option) {
                var random = Math.random().toString(36).slice(2);
                return (React.createElement(tooltip_1.default, { key: option.name, content: option.tooltipText ? (React.createElement(body_1.default, { size: "xs", withoutMargins: true, style: { width: "max-content", maxWidth: 500 } }, option.tooltipText)) : null, position: "bottom" },
                    React.createElement(Styled.AdminRadioInputItem, { onClick: function () {
                            !readOnly && !option.disabled && onChange(option.name);
                        }, key: option.name, readOnly: readOnly || option.disabled, appearance: appearance, selected: option.name === value },
                        React.createElement(Styled.AdminRadioInputItemVector, { isChecked: option.name === value, variant: variant, readOnly: readOnly || option.disabled }),
                        React.createElement(Styled.LabelContainer, null,
                            React.createElement(Styled.AdminRadioInputItemName, { readOnly: readOnly || option.disabled, "data-tip": true, "data-for": random }, option.label),
                            option.iconRight && option.iconRight))));
            }))));
    }
};
exports.default = Radio;
